import React from 'react';

import { addToAgendaQueueAction } from 'actions/addConsumeAgendaActions';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { StyledTooltip } from 'styles/common';

import { AGENDA_TAG_LABEL_TYPES, MESH_LIST_TABS } from 'constants/ProjectConstants';
import { PlusIcon2, StyledIconV2 } from 'constants/icons';
import { sendAddedToOneononeAgenda, sendAddedToOneOnOneAgendaEvent } from 'constants/mixpanelHelper';

const Container = styled.div`
  visibility: ${(props) => (props.$isHiddenByDefault ? 'hidden' : 'visible')};
`;

const AddToAgendaComponent = ({
  className,
  type,
  task = null,
  goal = null,
  feedback = null,
  levelUpCompetency = null,
  isHiddenByDefault = true,
}) => {
  // send to redux for agenda container to consume.

  const dispatch = useDispatch();

  const { userRole } = useSelector(selectLoggedInEmployeeData);
  const addToAgenda = (ev) => {
    ev.stopPropagation();

    let labelType = null;
    let uuid = null;
    let levelUpInfo;

    switch (type) {
      case MESH_LIST_TABS.task.taskType:
        labelType = AGENDA_TAG_LABEL_TYPES.LABEL_TASK.value;
        uuid = task?.uuid;
        sendAddedToOneononeAgenda({
          eventProperties: {
            role: userRole,
            type: MESH_LIST_TABS.task.displayName,
          },
        });

        break;
      case MESH_LIST_TABS.goal.taskType:
        labelType = AGENDA_TAG_LABEL_TYPES.LABEL_GOAL.value;
        uuid = goal?.id;
        sendAddedToOneononeAgenda({
          eventProperties: {
            role: userRole,
            type: MESH_LIST_TABS.goal.displayName,
          },
        });

        break;
      case MESH_LIST_TABS.feedback.taskType:
        labelType = AGENDA_TAG_LABEL_TYPES.LABEL_FEEDBACK.value;
        uuid = feedback?.id;
        sendAddedToOneononeAgenda({
          eventProperties: {
            role: userRole,
            type: MESH_LIST_TABS.feedback.displayName,
          },
        });

        break;
      case MESH_LIST_TABS.levelUp.taskType:
        labelType = AGENDA_TAG_LABEL_TYPES.LABEL_LEVELUP.value;
        uuid = `${levelUpCompetency?.levelUpId}__${levelUpCompetency?.competencyId}__${levelUpCompetency?.subCompetencyId}`;
        levelUpInfo = levelUpCompetency;

        sendAddedToOneononeAgenda({
          eventProperties: {
            role: userRole,
            type: MESH_LIST_TABS.levelUp.displayName,
          },
        });

        sendAddedToOneOnOneAgendaEvent({
          eventProperties: {
            type: 'LevelUp',
          },
        });

        break;
      default:
        break;
    }

    if (labelType && uuid) {
      dispatch(
        addToAgendaQueueAction({
          labelType,
          uuid,
          isTagged: true,
          levelUpInfo,
        })
      );
    }
  };

  return (
    <Container className={className} $isHiddenByDefault={isHiddenByDefault}>
      <StyledTooltip title="Add to Agenda">
        <StyledIconV2
          size="fixed10px"
          containerSize="fixed24px"
          circularOutline
          color="primary"
          bgColor="white"
          style={{ flex: '0 0 auto' }}
          rightGutter={1}
          onClick={addToAgenda}
        >
          <PlusIcon2 />
        </StyledIconV2>
      </StyledTooltip>
    </Container>
  );
};

export default AddToAgendaComponent;
